(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  function initToutvaReviewsCarousel(root) {
    root.querySelectorAll('[data-reviews-carousel]').forEach(function (carousel) {
      if (carousel.dataset.reviewsReady === 'true') return;

      var viewport = carousel.querySelector('[data-reviews-viewport]');
      var previous = carousel.querySelector('[data-reviews-prev]');
      var next = carousel.querySelector('[data-reviews-next]');
      var current = carousel.querySelector('[data-reviews-current]');
      var cards = Array.prototype.slice.call(carousel.querySelectorAll('[data-review-column]'));
      var total = carousel.querySelector('[data-reviews-total]');
      if (total) total.textContent = String(cards.length);
      if (!viewport || !previous || !next || !cards.length) return;

      carousel.dataset.reviewsReady = 'true';
      var ticking = false;

      function getCurrentIndex() {
        var viewportLeft = viewport.getBoundingClientRect().left;
        var closestIndex = 0;
        var closestDistance = Infinity;

        cards.forEach(function (card, index) {
          var distance = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function updateControls() {
        var index = getCurrentIndex();
        var reachedEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;

        if (current) current.textContent = String(index + 1);
        previous.disabled = viewport.scrollLeft <= 4;
        next.disabled = reachedEnd;
        ticking = false;
      }

      function scrollReviews(direction) {
        var index = getCurrentIndex();
        var targetIndex = Math.max(0, Math.min(cards.length - 1, index + direction));
        var viewportLeft = viewport.getBoundingClientRect().left;
        var targetLeft = cards[targetIndex].getBoundingClientRect().left - viewportLeft + viewport.scrollLeft;
        viewport.scrollTo({ left: targetLeft, behavior: 'smooth' });
      }

      previous.addEventListener('click', function () {
        scrollReviews(-1);
      });

      next.addEventListener('click', function () {
        scrollReviews(1);
      });

      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateControls);
      }, { passive: true });

      window.addEventListener('resize', updateControls, { passive: true });
      updateControls();
    });
  }

  initToutvaReviewsCarousel(document);

  document.addEventListener('shopify:section:load', function (event) {
    initToutvaReviewsCarousel(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
